<template>
  <div class="tips-popup">
    <a class="close" @click="close"></a>
    <p>{{ text }}</p>
  </div>
</template>

<script type="text/javascript">
export default {
  props: ["text"],
  methods: {
    close() {
      this.$parent.toggleCommonTips(false);
    }
  }
};
</script>
